// IMPORTS
// schema
import * as ISchema from "@schema";

import { commitMutation } from "react-relay";
import { Environment } from "relay-runtime";
import { setWorkAddressForUserMutation } from "./SetWorkAddressForUser.gql";
import { modernCache } from "@network/modern-network-layer";

// TYPES
interface ISetWorkAddressForUserMutationResponse {
  setWorkAddressForUser: ISchema.ISetWorkAddressForUserMutationPayload;
}

// MUTATION
export function setWorkAddressForUser(
  environment: Environment,
  input: ISchema.ISetWorkAddressForUserMutationInput,
  onSuccess: (response?: ISchema.ISetWorkAddressForUserMutationPayload) => void,
  onError: (error?: any) => void,
) {
  commitMutation(environment, {
    onError,
    mutation: setWorkAddressForUserMutation,
    variables: { input },
    onCompleted: (response: ISetWorkAddressForUserMutationResponse, errors?: Error[]) => {
      if (!!errors) {
        onError(errors[0]);
      } else {
        // if we're not in a modern environment, modernCache will be undefined
        if (modernCache) {
          modernCache.clear();
        }
        onSuccess(response.setWorkAddressForUser);
      }
    },
    updater: (store, _data) => {
      // const { address } = data.setWorkAddressForUser;
      // get the org from store
      const orgProxy = store.get(input.orgRelayId);
      if (!orgProxy) {
        return;
      }

      const addressId = `client:${input.orgRelayId}:workAddressForUser`;
      let addressProxy = orgProxy.getLinkedRecord("workAddressForUser");

      // sanity
      if (!addressProxy) {
        addressProxy = store.create(addressId, "Address");
      }

      if (addressProxy.getValue("__typename") === "GraphEntityError") {
        // HACK - cannot seem to convert this into an Address without error
        // but we need to update others for the initial set of the object
        // so switch statusCode to 200, and transmit the rawAddress as a message
        addressProxy.setValue(200, "statusCode");
        addressProxy.setValue(input.rawAddress, "message");
      } else {
        // just update the address
        addressProxy.setValue(input.rawAddress, "rawAddress");
      }

      // update
      orgProxy.setLinkedRecord(addressProxy, "workAddressForUser");
    },
  });
}
